import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = () => ({
  webhooks: [],
  webhooksTriggers: [],
  webhooksLoading: false,
  removeWebhookLoading: false,
  addUpdateWebhookLoading: false,
  webhook: null,
});

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
